import { T_HEADER_PAGE_CONSTANTS } from './TYPES'

const HU_HEADER_PAGE_CONSTANTS: T_HEADER_PAGE_CONSTANTS = {
  PROFILE_TEXT: 'Profil',
  LOGOUT_TEXT: 'Kijelentkezés'
}

export default HU_HEADER_PAGE_CONSTANTS
